import { twMerge } from "tailwind-merge";
import { Textarea } from "../Textarea";
import { Button } from "../Button";
import { ArrowUp } from "lucide-react";
import { ChangeEvent, KeyboardEvent, useRef, useState } from "react";
import { useChat } from "../../context/ChatContext";
import Suggestions from "./Suggestions";
import { AnimatePresence, motion } from "framer-motion";

const Prompt = () => {
    const [text, setText] = useState('');
    const textAreaRef = useRef<HTMLTextAreaElement | null>(null);

    const { handleSubmit, isStreaming, messages } = useChat();

    const handlePrompt = (e: ChangeEvent<HTMLTextAreaElement>) => {
        setText(e.currentTarget.value);
    };

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault()
            e.stopPropagation()

            handlePromptSubmit();
        }
    }

    const handlePromptSubmit = async () => {
        if (!text) return;

        if (textAreaRef && textAreaRef.current) textAreaRef.current.value = '';

        handleSubmit(text);
    }

    return (
        <>
            <AnimatePresence mode="sync">
                {
                    messages.length > 0 && (
                        <motion.div initial={{ y: 10 }} animate={{ y: 0 }} transition={{ duration: .2 }} className="mb-1">
                            <Suggestions inline={true} />
                        </motion.div>
                    )
                }
            </AnimatePresence>
            <div className="relative">
                <div className={twMerge(
                    "group w-full glow-ia h-auto rounded-[1.3rem] shadow-[0rem_.3125rem_.3125rem_-.15625rem_#00000008,0rem_.1875rem_.1875rem_-.09375rem_#00000005,0rem_.125rem_.125rem_-.0625rem_#00000005,0rem_.0625rem_.0625rem_-.03125rem_#00000008,0rem_.03125rem_.03125rem_0rem_#0000000a,0rem_0rem_0rem_.0625rem_#0000000f]"
                )}>
                    <div className="bg-white size-full mb-[10px] relative flex flex-row items-center rounded-[1.3rem] p-0 px-[10px]">
                        <Textarea ref={textAreaRef} onKeyDownCapture={handleKeyDown} onChange={handlePrompt} className="w-full custom-scroll zero-scroll resize-none outline-none overflow-auto overscroll-contain py-3 pl-[2px] whitespace-pre-wrap break-words border-0 min-h-[none] ring-0 text-xs placeholder:text-xs text-gray-900  [mask-image:linear-gradient(rgba(0,0,0,0),rgb(0,0,0)_15px,rgb(0,0,0)_calc(100%+0px),rgba(0,0,0,0))] [-webkit-mask-image:linear-gradient(rgba(0,0,0,0),rgb(0,0,0)_15px,rgb(0,0,0)_calc(100%+0px),rgba(0,0,0,0))]" placeholder="Pergunte qualquer coisa...">

                        </Textarea>

                        <Button onClick={handlePromptSubmit} disabled={text.length <= 0 || isStreaming} size={'icon'} className="size-6 rounded-full flex-shrink-0 bg-[#854BEF] disabled:bg-gray-900">
                            <ArrowUp />
                        </Button>
                    </div>
                </div>
            </div>
        </>
    )
};

export default Prompt;